import React, { Suspense } from 'react';

const DelayedCampaignCreationMethodSelectionStep =
  React.lazy(() => import(/* webpackChunkName: "campaign-creation-method-selection-step.async" */ './campaign-creation-method-selection-step')
    .then(({ CampaignCreationMethodSelectionStepWithI18n }) => ({
      default: CampaignCreationMethodSelectionStepWithI18n,
    })));

export const DelayedCampaignCreationMethodSelectionStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedCampaignCreationMethodSelectionStep />
  </Suspense>
);
